import React, { useEffect, useState } from "react";
import { getStudentsByDob, updateStudentWish } from "../services/api";
import { formatDate } from "../utils/helpers";
import { showAppToast } from "../utils/feedback";
import "./BirthdayWishesPage.css";

function BirthdayWishesPage() {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [savingId, setSavingId] = useState("");

  const extractMonthDay = (dobValue) => {
    const value = String(dobValue || "").trim();
    if (!value) {
      return null;
    }

    const ymd = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (ymd) {
      return { month: ymd[2], day: ymd[3] };
    }

    const dmy = value.match(/^(\d{2})[-/](\d{2})[-/](\d{4})$/);
    if (dmy) {
      return { month: dmy[2], day: dmy[1] };
    }

    return null;
  };

  const loadTodayBirthdays = async () => {
    try {
      setLoading(true);
      const now = new Date();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
        const res = await getStudentsByDob({ month, day, includeImages: true });
      const strictTodayBirthdays = (res.data || []).filter((s) => {
        const md = extractMonthDay(s.dob);
        return md && md.month === month && md.day === day;
      });
      setStudents(strictTodayBirthdays);
    } catch (error) {
      showAppToast({
        type: "error",
        title: "Failed to load birthdays",
        message: error.response?.data?.error || "Could not load birthday students."
      });
      setStudents([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadTodayBirthdays();
  }, []);

  const updateField = (id, field, value) => {
    setStudents((current) =>
      current.map((s) => (s._id === id ? { ...s, [field]: value } : s))
    );
  };

  const saveWish = async (student) => {
    try {
      setSavingId(student._id);
      await updateStudentWish(student._id, {
        wishingStatus: student.wishingStatus || "Wished",
        wishMessage: student.wishMessage || "Happy Birthday"
      });
      showAppToast({
        type: "success",
        title: "Wish updated",
        message: `Wish status saved for ${student.name}.`
      });
    } catch (error) {
      showAppToast({
        type: "error",
        title: "Failed to save wish",
        message: error.response?.data?.error || "Could not save wish status."
      });
    } finally {
      setSavingId("");
    }
  };

  return (
    <section className="birthday-wishes">
      <div className="birthday-wishes__head">
        <h1>Birthday Wishes</h1>
        <button onClick={loadTodayBirthdays} disabled={loading}>
          {loading ? "Refreshing..." : "Refresh"}
        </button>
      </div>

      {students.length === 0 && !loading && <div className="birthday-wishes__empty">No birthdays today.</div>}

      <div className="birthday-wishes__grid">
        {students.map((student) => (
          <article key={student._id} className="birthday-wishes__card">
            <img src={student.imageData || student.imageUrl || "/logo.jpeg"} alt={student.name} />
            <div>
              <strong>{student.name}</strong>
              <p>Class: {student.class || "-"}</p>
              <p>DOB: {formatDate(student.dob)}</p>
            </div>
            <label>
              Wishing Status
              <select
                value={student.wishingStatus || "Pending"}
                onChange={(e) => updateField(student._id, "wishingStatus", e.target.value)}
              >
                <option value="Pending">Pending</option>
                <option value="Wished">Wished</option>
              </select>
            </label>
            <label>
              Wish Message
              <input
                value={student.wishMessage || ""}
                onChange={(e) => updateField(student._id, "wishMessage", e.target.value)}
                placeholder="Happy Birthday!"
              />
            </label>
            <button onClick={() => saveWish(student)} disabled={savingId === student._id}>
              {savingId === student._id ? "Saving..." : "Save Wish"}
            </button>
          </article>
        ))}
      </div>
    </section>
  );
}

export default BirthdayWishesPage;
